import React from "react";
import { useAuth } from "../context/AuthContext";
import { OnboardingWizard } from "./OnboardingWizard";

/**
 * Mounts the OnboardingWizard whenever a signed-in user hasn't completed onboarding.
 * Renders nothing otherwise — page content underneath stays visible (the wizard is a
 * full-screen modal on top).
 */
export const OnboardingGate = () => {
    const { user } = useAuth();
    if (!user || user.onboarded_at) return null;
    return <OnboardingWizard />;
};
